import React from 'react';
import { Users, Briefcase } from 'lucide-react';
import { useApp, resolveImg } from '../context/AppContext';
import { fleetSection } from '../mock/content';
import { currencySymbols, rates } from '../mock/mock';
import {
  Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext,
} from './ui/carousel';

// Blacklane-style fleet slideshow driven by the shared vehicle list.
const FleetSlider = () => {
  const { lang, currency, vehicles } = useApp();
  const s = fleetSection[lang] || fleetSection.en;
  const fmt = (n) => `${currencySymbols[currency]} ${Math.round(n * rates[currency])}`;

  return (
    <Carousel opts={{ align: 'start', loop: true }} className="w-full">
      <CarouselContent className="-ml-4">
        {vehicles.map((v) => (
          <CarouselItem key={v.id} className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3">
            <div className="card-hover bg-white rounded-2xl overflow-hidden border border-gray-100 h-full flex flex-col">
              <div className="relative h-52 bg-[color:var(--brand-muted)]">
                <img src={resolveImg(v.img)} alt={v.name} className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3 bg-white/95 rounded-full px-3 py-1 text-xs font-bold text-[color:var(--brand-dark)] shadow">{v.name}</div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-sm text-gray-500 leading-relaxed flex-1">{v.model}</p>
                <div className="mt-4 flex items-center gap-4 text-sm text-[color:var(--brand-dark)] font-semibold">
                  <span className="flex items-center gap-1.5"><Users className="w-4 h-4" style={{ color: 'var(--brand-blue)' }} /> {v.pax}</span>
                  <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4" style={{ color: 'var(--brand-blue)' }} /> {v.bags}</span>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-gray-400">{s.from} <b className="text-[color:var(--brand-dark)] text-base">{fmt(90 * v.priceFactor)}</b></span>
                  <a href="/#book" className="accent-btn rounded-full px-4 py-2 text-xs font-bold">{s.book}</a>
                </div>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden sm:flex -left-3" />
      <CarouselNext className="hidden sm:flex -right-3" />
    </Carousel>
  );
};

export default FleetSlider;
